import { z } from "zod";

export const clientOnboardingSchema = z.object({
  step1: z.object({
    email: z
      .string()
      .email("Please enter valid email")
      .min(3, "Email must be at least 3 characters long")
      .max(255, "Email must be at most 255 characters long"),
  }),
  step2: z.object({
    otp: z.string().min(6, "Please enter complete OTP"),
  }),
});
export type clientOnboardingType = z.infer<typeof clientOnboardingSchema>;
